import Group from './Group.js';
import InternalInput from './Input.js';
import OTP from './OTP/index.js';
import Password from './Password.js';
import Search from './Search.js';
import TextArea from './TextArea.js';
const Input = InternalInput;
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
Input.OTP = OTP;
var AntInput = Input;
export { AntInput as default };
//# sourceMappingURL=index.js.map
